import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
} from "@angular/core";
import { SpsTableCellWrapWidth } from "@spscommerce/ds-shared";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { PinnableTableCell } from "../pinnable-table-cell";

@Component({
    selector: "sps-table-cell, sps-td",
    templateUrl: "./sps-table-cell.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTableCellComponent extends PinnableTableCell implements OnChanges {
    static readonly displayName = "sps-table-cell / sps-td";
    static readonly props = {
        ...PinnableTableCell.props,
        wrap: "SpsTableCellWrapWidth",
        controlCell: "boolean",
        buttonCell: "boolean",
    };

    @HostBinding("attr.role") readonly _roleAttr = "cell";
    @HostBinding("class.sps-table__cell") readonly _spsTableCellClass = true;

    @Input() wrap: SpsTableCellWrapWidth;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-table__cell--control")
    controlCell: boolean;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-table__cell--button-cell")
    buttonCell: boolean;

    constructor(
        protected changeDetector: ChangeDetectorRef,
        private _elementRef: ElementRef,
        private _renderer: Renderer2
    ) {
        super();
    }

    static wrapClass(wrapWidth: number) {
        return `sps-table__cell--text-wrap-${wrapWidth}`;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.wrap) {
            this._renderer.removeClass(
                this._elementRef.nativeElement,
                SpsTableCellComponent.wrapClass(changes.wrap.previousValue)
            );
            this._renderer.addClass(
                this._elementRef.nativeElement,
                SpsTableCellComponent.wrapClass(changes.wrap.currentValue)
            );
        }
    }
}
